import React, { useState, useEffect } from "react";
import FormatDateTime from "../../utils/formatDateTime";

import { ChevronsUpDownIcon, RefreshCcwIcon, FilterIcon } from "lucide-react";
import LoadingSpinner from "../../components/loading-spinner";
import { handleSortStraddleData } from "../../utils/sortFunctions";
import FilterStraddleHistoryModal from "./filterStraddleHistoryModal";

export default function FyersStraddleHistoryTable({
  fyersStraddleHistoryData,
  setStraddleData,
  filteredFyersStraddleHistoryData,
  setFilteredFyersStraddleHistoryData,
  handleResetFilterData,
  sortOrder,
  setSortOrder,
  ...props
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(true);

  let itemsPerPage = 20;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = fyersStraddleHistoryData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(fyersStraddleHistoryData.length / itemsPerPage);

  const displayPageNumbers = () => {
    const pageNumbers = [];
    const maxPageButtons = 5; // You can adjust this value based on your preference

    let startPage;
    let endPage;

    if (totalPages <= maxPageButtons) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= Math.ceil(maxPageButtons / 2)) {
        startPage = 1;
        endPage = maxPageButtons;
      } else if (currentPage + Math.floor(maxPageButtons / 2) >= totalPages) {
        startPage = totalPages - maxPageButtons + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - Math.floor(maxPageButtons / 2);
        endPage = currentPage + Math.floor(maxPageButtons / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          className={`flex items-center justify-center text-xs  font-semibold rounded-full h-5 w-5 ${
            currentPage === i
              ? "bg-[#07F2C7] text-black"
              : "bg-white/10 text-white/40"
          }`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }

    return pageNumbers;
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRefreshData = () => {
    console.log("Handle Refresh data");
    handleResetFilterData();
  };

  const handleShowFilter = () => {
    setShowFilter(true);
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 700);

    return () => clearTimeout(timer);
  }, []);

  //  console.log("Straddle Data --->",fyersStraddleHistoryData)
  return (
    <>
      {fyersStraddleHistoryData && fyersStraddleHistoryData?.length === 0 ? (
        <div className="w-full h-full flex flex-col items-center justify-center text-white">
          {loading ? <LoadingSpinner /> : " No Straddle Dashboard Data Found!!"}
        </div>
      ) : (
        <>
          <div className="z-0 w-full h-[calc(100vh-240px)]  md:h-[calc(100vh-320px)]  lg:h-[calc(100vh-60px)] custom-scroll overflow-x-auto  shadow-md animate-reveal transition-all duration-500 ease-in">
            <table className="bg-black   text-sm w-full relative z-0 ">
              <thead className="bg-black text-sm text-left sticky top-0 box-border  ">
                <tr className="text-white border-b  border-gray-800 ">
                  <th className=" px-4 py-3 font-semibold  ">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortStraddleData(
                          filteredFyersStraddleHistoryData,
                          setFilteredFyersStraddleHistoryData,
                          setSortOrder,
                          sortOrder,
                          "underlying_scrip_code"
                        )
                      }
                    >
                      Symbol
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </th>

                  <th className=" px-4 py-3 font-semibold ">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortStraddleData(
                          filteredFyersStraddleHistoryData,
                          setFilteredFyersStraddleHistoryData,
                          setSortOrder,
                          sortOrder,

                          "straddle_ratio"
                        )
                      }
                    >
                      Cost of straddle (%)
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </th>
                  <th className=" px-4 py-3 font-semibold ">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortStraddleData(
                          filteredFyersStraddleHistoryData,
                          setFilteredFyersStraddleHistoryData,
                          setSortOrder,
                          sortOrder,
                          "underlying_ltp"
                        )
                      }
                    >
                      LTP
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </th>

                  <th className=" px-4 py-3 font-semibold ">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortStraddleData(
                          filteredFyersStraddleHistoryData,
                          setFilteredFyersStraddleHistoryData,
                          setSortOrder,
                          sortOrder,
                          "ce_ltp"
                        )
                      }
                    >
                      CALL LTP
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </th>
                  <th className="   px-4 py-3 font-semibold">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortStraddleData(
                          filteredFyersStraddleHistoryData,
                          setFilteredFyersStraddleHistoryData,
                          setSortOrder,
                          sortOrder,
                          "pe_ltp"
                        )
                      }
                    >
                      PUT LTP
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </th>

                  <th className="min-w-[190px] lg:min-w-full lg:flex lg:justify-between px-4 py-4 ">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortStraddleData(
                          filteredFyersStraddleHistoryData,
                          setFilteredFyersStraddleHistoryData,
                          setSortOrder,
                          sortOrder,
                          "datetime"
                        )
                      }
                    >
                      Date
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                    <div className="hidden lg:flex space-x-2">
                      <span
                        onClick={handleRefreshData}
                        className={`flex items-center cursor-pointer bg-white/10 active:bg-[#07F2C7]/20  rounded-md  h-8 w-8`}
                      >
                        <RefreshCcwIcon className="h-4 w-4 text-[#07F2C7] ml-2" />
                      </span>

                      <span
                        onClick={handleShowFilter}
                        className={`${
                          showFilter ? " bg-[#07F2C7]/20" : "bg-white/10 "
                        } flex items-center cursor-pointer   rounded-md  h-8 w-8`}
                      >
                        <FilterIcon className="h-4 w-4 text-[#07F2C7] ml-2" />
                      </span>
                    </div>
                  </th>
                </tr>
                {showFilter && (
                  <FilterStraddleHistoryModal
                    showFilter={showFilter}
                    handleCloseFilter={handleCloseFilter}
                    fyersStraddleHistoryData={fyersStraddleHistoryData}
                    setFilteredFyersStraddleHistoryData={
                      setFilteredFyersStraddleHistoryData
                    }
                  />
                )}
              </thead>

              <tbody>
                {filteredFyersStraddleHistoryData &&
                  filteredFyersStraddleHistoryData?.map((item, index) => (
                    <tr
                      key={index}
                      className="bg-black z-0 border-b   border-gray-900 font-medium text-white hover:bg-black/90"
                    >
                      <td className="px-4 py-4 border-r border-gray-900 ">
                        {item.underlying_scrip_code}
                      </td>

                      <td className="px-4 py-4 border-r border-gray-900">
                        {item.straddle_ratio}%
                      </td>
                      <td className="px-4 py-4 border-r border-gray-900">
                        {item.underlying_ltp}
                      </td>
                      <td className="px-4 py-4 border-r border-gray-900">
                        {item.ce_ltp}
                      </td>
                      <td className="px-4 py-4 border-r border-gray-900">
                        {item.pe_ltp}
                      </td>
                      <td className="px-4 py-4 border-r border-gray-900">
                        {FormatDateTime(item.datetime)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}


